<template>
	<transition name="fade-in-down">
		<div :class="classes" v-show="visible">
			<img class="icon" :src="icon" alt />
			<slot>
				<p v-if="!dangerouslyUseHTMLString" class="el-message__content">
					{{ content }}
				</p>
				<p v-else v-html="content" class="el-message__content"></p>
			</slot>
		</div>
	</transition>
</template>
<script>
import info from '../../assets/images/info.png'
import success from '../../assets/images/check.png'
import error from '../../assets/images/error.png'

const icons = {
	info,
	success,
	error,
}
const prefix = 'ns-message'
export default {
	name: 'message',
	data() {
		return {
			visible: false,
			type: 'info',
			dangerouslyUseHTMLString: false,
		}
	},
	computed: {
		classes() {
			return `${prefix}
				${prefix}--${this.type}
				${prefix}--${this.align}`
		},
		icon() {
			return icons[this.type]
		},
	},
}
</script>

<style lang="scss" scoped>
.ns-message {
	min-width: 380px;
	box-sizing: border-box;
	border-width: 1px;
	border-style: solid;
	border-color: rgb(235, 238, 245);
	position: fixed;
	z-index: 99;
	left: 50%;
	top: 20px;
	transform: translateX(-50%);
	background-color: rgba(237, 242, 252, 0.8);
	padding: 15px 15px 15px 20px;
	display: flex;
	align-items: center;
	.icon {
		width: 16px;
		height: 16px;
		margin-right: 10px;
	}
}
.ns-message.ns-message--warning {
	background-color: rgb(253, 246, 236);
	border-color: rgb(250, 236, 216);
	color: rgb(230, 162, 60);
}
.ns-message.ns-message--success {
	background-color: rgb(240, 249, 235);
	border-color: rgb(225, 243, 216);
	color: rgb(103, 194, 58);
}
.ns-message.ns-message--left {
	justify-content: flex-start;
}
.ns-message.ns-message--center {
	justify-content: center;
}
.ns-message.ns-message--error {
	background-color: rgb(254, 240, 240);
	border-color: rgb(253, 226, 226);
}
.fade-in-down-enter-active,
.fade-in-down-leave-active {
	transition-property: opacity top;
	transition-duration: 0.5s;
}
.fade-in-down-enter,
.fade-in-down-leave-to {
	opacity: 0;
	top: -100px;
}
</style>
